module.exports = __webpack_public_path__ + "static/media/shayan.9d4c4448.svg";